import React, { Component } from 'react';
import { Card, Form, Button, message, Space, Radio } from 'antd-v5';
import { getSmsSupplierRequest, switchSupplierRequest } from '../../state/request/sms';
import './index.less';

class SmsOperatorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      smsSupplier: null,
    };
  }

  // 应用类型选项
  supplierOptions = [
    { value: 'ALIYUN', label: '阿里云' },
    { value: 'TENCENT', label: '腾讯云' },
  ];

  componentDidMount() {
    this.getSmsSupplier();
  }

  getSmsSupplier = async () => {
    const response = await getSmsSupplierRequest();
    if (response.code === 200) {
      this.form.setFieldsValue({
        smsSupplierEnum: response.data,
      });
    }
  };

  // 处理查询
  handleSave = async (values) => {
    const { smsSupplierEnum } = values;

    if (!smsSupplierEnum) {
      message.error('请选择短信运营商');
      return;
    }

    this.setState({ loading: true });

    try {
      const response = await switchSupplierRequest(smsSupplierEnum);
      if (response.code === 200) {
        message.success('保存成功');
      }
    } catch (error) {
      message.error('保存失败');
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;

    return (
      <div className='sms-code-page'>
        <div className='page-container'>
          <Card className='search-card' title='短信运营商'>
            <Form
              ref={(form) => (this.form = form)}
              name='smsCodeForm'
              onFinish={this.handleSave}
              layout='inline'
              className='search-form'
            >
              <Form.Item
                label='短信运营商'
                name='smsSupplierEnum'
                rules={[{ required: true, message: '请选择短信运营商' }]}
              >
                <Radio.Group options={this.supplierOptions} />
              </Form.Item>

              <Form.Item>
                <Space>
                  <Button type='primary' htmlType='submit' loading={loading}>
                    保存配置
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
    );
  }
}

export default SmsOperatorPage;
